import APIService from '@/api'

export default class APIPeriod extends APIService{

    constructor(){
        super('periods')
    }

    async getAll() {
        var response = await this.AxiosInstance
            .get(this.ApiUrl, { params: { } })
            .catch(error => {
              console.log(error.response)
            });
        return response;
    }
}



// WEBPACK FOOTER //
// ./src/api/period.js